/**
 * Drag-and-drop utilities for transferring generated images
 * between result displays and upload zones across the app.
 */

const GENERATED_IMAGE_TYPE = 'application/x-generated-image';

/**
 * Sets drag data for a generated image on dragStart
 */
export const setGeneratedImageDragData = (e, imageUrl) => {
  e.dataTransfer.setData(GENERATED_IMAGE_TYPE, imageUrl);
  e.dataTransfer.setData('text/uri-list', imageUrl);
  e.dataTransfer.setData('text/plain', imageUrl);
  e.dataTransfer.effectAllowed = 'copy';
};

/**
 * Extracts a generated image URL from a drop event (returns null if not present)
 */
export const getGeneratedImageUrl = (e) => {
  return e.dataTransfer.getData(GENERATED_IMAGE_TYPE) ||
         e.dataTransfer.getData('text/uri-list') ||
         null;
};

/**
 * Checks if a drop event contains a generated image (no files, but has URL)
 */
export const isGeneratedImageDrop = (e) => {
  const hasFiles = e.dataTransfer.files && e.dataTransfer.files.length > 0;
  if (hasFiles) return false;
  const url = getGeneratedImageUrl(e);
  return !!url;
};

/**
 * Fetches an image URL and returns a File object
 */
export const urlToFile = async (url, filename = 'generated-image.png') => {
  const response = await fetch(url);
  const blob = await response.blob();
  const type = blob.type || 'image/png';
  return new File([blob], filename, { type });
};

/**
 * Fetches an image URL and returns a data URL string
 */
export const urlToDataUrl = (url) => {
  return new Promise((resolve, reject) => {
    const img = new window.Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      canvas.getContext('2d').drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = reject;
    img.src = url;
  });
};
